import { z } from 'zod';

export const profileSchema = z
  .object({
    name: z
      .string()
      .min(2, 'Name must be at least 2 characters')
      .max(100, 'Name must not exceed 100 characters')
      .regex(/^[a-zA-Z\s]+$/, 'Name can only contain letters and spaces'),

    email: z
      .string()
      .email('Invalid email address')
      .min(5, 'Email must be at least 5 characters')
      .max(100, 'Email must not exceed 100 characters'),

    phoneNumber: z
      .string()
      .regex(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
      .optional()
      .or(z.literal('')),

    // Two-Factor Authentication
    twoFactorAuthEnabled: z.boolean().optional(),

    twoFactorAuthSecret: z.string().min(1, 'Secret key is required when 2FA is enabled').optional().or(z.literal('')),

    // IP Whitelist
    ipWhitelist: z.string().optional().or(z.literal('')),
  })
  .refine(
    (data) => {
      // If 2FA is enabled, secret must be provided
      if (data.twoFactorAuthEnabled && !data.twoFactorAuthSecret) {
        return false;
      }
      return true;
    },
    {
      message: 'Secret key is required when Two-Factor Authentication is enabled',
      path: ['twoFactorAuthSecret'],
    }
  );
